import { render, staticRenderFns } from "./logActivityStatistics.vue?vue&type=template&id=63c6b2f5"
import script from "./logActivityStatistics.vue?vue&type=script&lang=js"
export * from "./logActivityStatistics.vue?vue&type=script&lang=js"
import style0 from "./logActivityStatistics.vue?vue&type=style&index=0&id=63c6b2f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports